<template>
  <div class="liu" v-wechat-title="'身份认证'">
    <!-- 提示信息 -->
    <div class="tips page-padding-l-r">
      <span class="txt">身份认证照片</span>
    </div>
    <!-- 身份证 -->
    <div class="flex-s padding-t-10 padding-b-10 page-padding-l-r color-f-bg">
      <!-- Label-->
      <div style="width: 95px;">
        <span>证件照</span>
      </div>
      <!-- 头像页 -->
      <div class="align-center title-5 say-color" style="margin-right: 0.5rem;">
        <div class="id-card-style" @click="onCameraImgClick('renXiang')">
          <img v-if="renXiang.webUrl" class="img" :src="renXiang.webUrl" />
          <svg-icon v-else class-name="img" icon-class="authenticate-headshot" />
        </div>
        <div class="id-card-tips">头像页</div>
      </div>
      <!-- 国徽页 -->
      <div class="align-center title-5 say-color">
        <div class="id-card-style" @click="onCameraImgClick('guoHui')">
          <img v-if="guoHui.webUrl" class="img" :src="guoHui.webUrl" />
          <svg-icon v-else class-name="img" icon-class="authenticate-emblem" />
        </div>
        <div class="id-card-tips">国徽页</div>
      </div>
    </div>
    <!-- 提示信息2 -->
    <div v-show="bottomTipsIsShow" class="tips page-padding-l-r height">
      <span class="txt">对准身份证拍摄字体清晰且四周边框完整的照片</span>
    </div>
    <!-- 提交按钮 -->
    <div class="padding-t-10 padding-b-10 page-padding-l-r">
      <mt-button v-show="flowStep === 1" type="primary" size="large" @click="onAgainBtnClick">重新认证</mt-button>
      <mt-button v-show="flowStep === 2" type="primary" size="large" :disabled="!renXiang.webUrl || !guoHui.webUrl"
        @click="onSubmitBtnClick">提交</mt-button>
    </div>
    <!-- 照片弹窗 -->
    <mt-popup v-model="popup.visible" pop-transition="popup-fade" :closeOnClickModal="false">
      <div class="img-box">
        <img class="id-card-img" :src="popup.photoImg" />
      </div>
      <div class="btn-box" @click="onPopupCloseClick">
        <span class="btn-txt">关闭</span>
      </div>
    </mt-popup>
  </div>
</template>

<script>
/* global wx */

import SvgIcon from '@/components/SvgIcon';
import { UploadIdCardImg } from '@/api/weChat.js';
import { CusToast, CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';

export default {
  name: 'UpdateIdCard',
  components: { SvgIcon },
  data() {
    return {
      flowStep: 1, // 2025.5.27 流程标识
      // 身份证人像面
      renXiang: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 身份证国徽面
      guoHui: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 弹窗对象
      popup: {
        visible: false,
        photoImg: ''
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.flowStep = parseInt(this.$route.query.flowstep);
      if (this.flowStep === 1) {
        this.renXiang.webUrl = decodeURIComponent(this.$route.query.rxweburlold).replace('|', '?');
        this.guoHui.webUrl = decodeURIComponent(this.$route.query.ghweburlold).replace('|', '?');
      } else {
        const imgType = this.$route.query.imgtype;
        if (imgType) {
          this.renXiang.webUrl = decodeURIComponent(this.$route.query.rxweburl).replace('|', '?');
          this.guoHui.webUrl = decodeURIComponent(this.$route.query.ghweburl).replace('|', '?');
        }
      }
    });
  },
  computed: {
    bottomTipsIsShow() {
      return this.flowStep === 2;
    },
  },
  methods: {
    // 拍照组件点击事件
    onCameraImgClick(type) {
      switch (type) {
        case "renXiang":
        case "guoHui":
          if (this.flowStep === 1) {
            if (this[type].webUrl) {
              this.popup.visible = true;
              this.popup.photoImg = this[type].webUrl;
            } else {
              CusToast('无照片');
            }
          } else {
            const data = this.createPostMessage(type);
            wx.miniProgram.postMessage({ data });
            wx.miniProgram.redirectTo({
              url: '/pages/media/media',
            });
          }
          break;
      }
    },

    // 重新认证按钮点击事件
    onAgainBtnClick() {
      this.flowStep = 2;
      this.renXiang.webUrl = "";
      this.guoHui.webUrl = "";
    },

    // 提交数据按钮点击事件
    onSubmitBtnClick() {
      CusLoadingOpen();
      UploadIdCardImg({
        idcardFrontUrl: this.renXiang.webUrl,
        idCardBackUrl: this.guoHui.webUrl,
      })
        .then(res => {
          CusLoadingClose();
          if (res.code === 0) {
            // code为0，表示成功
            // 1.向小程序发消息，更新状态
            wx.miniProgram.postMessage({ data: { page: "refresh" } });
            // 2.显示成功提示信息，并跳转回小程序
            CusAlert(res.msg, () => wx.miniProgram.navigateBack());
          } else {
            // 反正code不为0，表示不成功
            if (res.code === 9030)
              // code为9030时，只显示错误提示信息，不跳转回小程序
              CusAlert(res.msg, () => {
                this.resetCameraInfo("renXiang");
                this.resetCameraInfo("guoHui");
              });
            else
              // 其它code码的情况，显示接口返回的错误提示信息，并跳转回小程序
              CusAlert(res.msg, () => wx.miniProgram.navigateBack());
          }
        })
        .catch(() => {
          CusLoadingClose();
        });
    },

    onPopupCloseClick() {
      this.popup.visible = false;
    },
    // 重新拍照
    resetCameraInfo(name) {
      this[name].base64 = '';
      this[name].fileUrl = '';
      this[name].webUrl = '';
    },
    // 创建向小程序传递消息的参数对象
    createPostMessage(imgTypeStr) {
      return {
        page: 'media',
        h5Page: 'UpdateIdCard',
        flowStep: this.flowStep,
        rxWebUrl: encodeURIComponent(this.renXiang.webUrl.replace('?', '|')),
        ghWebUrl: encodeURIComponent(this.guoHui.webUrl.replace('?', '|')),
        imgType: imgTypeStr,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.tips {
  line-height: 1;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;

  .txt {
    font-size: $title5;
    color: $explain-color;
  }

  &.height {
    height: 2rem;
  }
}

.id-card-style {
  width: 6rem;
  height: 4rem;
  vertical-align: middle;
  overflow: hidden;
  @include dynamic-color;

  .img {
    width: 100%;
    height: 100%;
  }
}

.id-card-tips {
  line-height: 1;
  padding-top: 0.2rem;
}

.mint-popup {
  border-radius: 0.5rem;
}

.img-box {
  width: 15rem;
  height: 12.5rem;
  padding-top: 0.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;

  .id-card-img {
    width: 100%;
    height: 100%;
  }
}

.btn-box {
  text-align: center;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;

  .btn-txt {
    font-size: $title3;
    @include dynamic-color;
  }
}
</style>
